export enum WorkbookRoute {
  details = 'details',
  dashboards = 'dashboards'
}
